export default "__VITE_ASSET__JwaR$9qU__"